







































import Vue from 'vue'
import FilterDropdown from '@/pages/common/filter-dropdown/FilterDropdown.vue'
import { DropdownItem } from '@/pages/common/types'
import Icon from '@/ui/icon/Icon.vue'
import {
  classesDropdownModel,
  $classes,
  $selectedClasses,
  $isSelectedAllClasses,
  unselectAllClasses,
  setSelectedClasses,
  deleteSelectedClass,
  loadClasses,
  selectAllClasses,
} from '@/pages/users/students/list/parts/classes-dropdown/classes-dropdown.model'

export default Vue.extend({
  components: {
    FilterDropdown,
    Icon,
  },
  effector: {
    ...classesDropdownModel.store,
    $classes,
    $selectedClasses,
    $isSelectedAllClasses,
  },
  props: {
    label: String,
  },
  data() {
    return {
      classesDropdownMethods: classesDropdownModel.methods,
    }
  },
  methods: {
    ...classesDropdownModel.methods,
    unselectAllClasses,
    onSelectItem(item: DropdownItem | null, selectedItems: DropdownItem[]) {
      if (item !== null) {
        const queryParams = selectedItems.map((element) => element.name).join()
        item.name === 'all' ? selectAllClasses() : setSelectedClasses(item)
        this.$emit('setItem', queryParams.length > 0 ? `${item.name},${queryParams}` : item.name)
      }
    },
    deleteCourse(event: MouseEvent, item: DropdownItem) {
      event.stopPropagation()
      event.preventDefault()
      deleteSelectedClass(item)
      this.$emit('setItem', item.name)
    },
  },
  mounted() {
    loadClasses()
  },
  destroyed() {
    unselectAllClasses()
  },
})
